module.exports = "/close-83f3dc7a4fec62eeebc878c2a2f62b52.svg";